"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class MembershipService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RES = 'user';
        this.getPersonMembershipDetail = async (userId) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RES}/membership/${userId}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getMembershipDetails = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/details?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getMembershipBenefits = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/benefits`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Inscripción de un curso al usuario (legacy).
         * @deprecated The method should not be used. Use postProductEnrollment from ProductService.
         */
        this.postMembershipCourseEnrollment = async (body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/courseenrollment`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.createMembershipProductOrder = async (body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/included-product-order`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.postCancelPersonMembership = async (body) => {
            var _a;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/cancelpersonmembership`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            else {
                const data = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.data;
                const error = data || response.statusText;
                return Promise.reject(error);
            }
            ;
        };
        this.objectToQueryString = (obj) => Object.keys(obj).map(key => {
            const value = obj[key];
            let parameter = `${key}=${value}`;
            if (Array.isArray(value)) {
                let multiValueParams = '';
                const lastIndex = value.length - 1;
                value.forEach((item, index) => multiValueParams += `${key}=${item}${index === lastIndex ? '' : '&'}`);
                return multiValueParams;
            }
            return parameter;
        }).join("&");
        /**
         * Método para obtener los planes activos de las membresías.
         * @param PlansParams Array para filtrar los planes 1=mensual,3=trimestral, 6=semestral, 12=anual
         * @returns Array de planes activos
         */
        this.getMembreshipFees = async (PlansParams = [1, 3, 6, 12]) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/fees?fees=${PlansParams}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
          * Método para obtener los planes activos de las membresías.
          * @param PlansParams Array para filtrar los planes 1=mensual,3=trimestral, 6=semestral, 12=anual
          * @returns Array de planes activos
          */
        this.getMembershipFees = async (PlansParams = [1, 3, 6, 12], personId = 0) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/fees?fees=${PlansParams}&personId=${personId}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Método para obtener los planes activos de las membresías.
         * @param slug Slug de la membresia
         * @returns Array de objeto de membresias perteneciente al slup
        */
        this.getMembershipFeesId = async (slug) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/fees/${slug}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.MembershipService = MembershipService;
